/**
 * Reports API service (managers).
 * Uses the shared axiosInstance (auth headers, token refresh, error toasts).
 * The env base URLs are absolute, so axios ignores the instance baseURL for them.
 */
import http from "../axiosInstance";

const SALES = process.env.REACT_APP_SALES_MANAGER; // .../api/sales-manager
const PROD = process.env.REACT_APP_API_PROD_MANAGER; // .../api/prod-manager

// Repeated keys (ownerId=1&ownerId=2) as Spring expects; empty values are dropped.
const toQuery = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    (Array.isArray(value) ? value : [value]).forEach((item) => {
      if (item !== "" && item !== null && item !== undefined)
        query.append(key, item);
    });
  });
  const text = query.toString();
  return text ? `?${text}` : "";
};

// Backend envelope: { status, message, data }
const get = async (base, path, params) => {
  const response = await http.get(`${base}${path}${toQuery(params)}`);
  const body = response?.data ?? response;
  return body?.data !== undefined ? body.data : body;
};

// Summary payloads are { meta, data: { kpis, charts, lists } } -> flatten to { meta, kpis, charts, lists }
const flattenSummary = (payload) => ({
  meta: payload?.meta || {},
  ...(payload?.data || {}),
});

export const salesApi = {
  overview: (params) =>
    get(SALES, "/reports/sales/overview", params).then(flattenSummary),
  clientSummary: (params) =>
    get(SALES, "/client/report/summary", params).then(flattenSummary),
  clientTable: (params) => get(SALES, "/client/report/table", params),
  leadSummary: (params) =>
    get(SALES, "/lead/report/summary", params).then(flattenSummary),
  leadTable: (params) => get(SALES, "/lead/report/table", params),
  enquirySummary: (params) =>
    get(SALES, "/enquiry/report/summary", params).then(flattenSummary),
  enquiryTable: (params) => get(SALES, "/enquiry/report/table", params),
};

export const productionApi = {
  operationSummary: (params) => get(PROD, "/operation-report/summary", params),
  operationTable: (params) => get(PROD, "/operation-report/table", params),
  completedOperations: (params) =>
    get(PROD, "/operation-stage-report/completed", params),
  warehouseSummary: (params) =>
    get(PROD, "/warehouse-stock/report/summary", params),
  warehouseStockLevels: (params) =>
    get(PROD, "/warehouse-stock/report/stock-levels", params),
  warehouseMovements: (params) =>
    get(PROD, "/warehouse-stock/report/movements", params),
};
